(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var TYPUJE = JSON.parse(String(__pewniaki_inline_cfg[0]));
    var q   = function (s) { return document.querySelector(s); };
    var set = function (s, v) { var el = q(s); if (el) { el.textContent = v; } };
    var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    var f1  = function (v) { return v == null || !isFinite(v) ? '—' : (Math.round(v * 10) / 10).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };

    // Wartosc modelu: liczba albo null. Brak klucza, null, napis nieliczbowy, bool i obiekt = brak, nie 0.
    function num(v) {
        if (v === null || v === undefined || v === '' || typeof v === 'boolean' || typeof v === 'object') { return null; }
        var n = Number(v);
        return isFinite(n) ? n : null;
    }
    var T13 = {
        brakD:  __pewniaki_inline_cfg[1],
        losN:   __pewniaki_inline_cfg[2],
        losA:   __pewniaki_inline_cfg[3],
        losU:   __pewniaki_inline_cfg[4],
        losW:   __pewniaki_inline_cfg[5],
        losWA:  __pewniaki_inline_cfg[6],
        para:   __pewniaki_inline_cfg[7],
        paraM:  __pewniaki_inline_cfg[8],
        paraB:  __pewniaki_inline_cfg[9],
        naj:    __pewniaki_inline_cfg[10],
        najM:   __pewniaki_inline_cfg[11],
        najB:   __pewniaki_inline_cfg[12]
    };
    function slowo(n, jeden, kilka, wiele) {
        var r10 = n % 10, r100 = n % 100;
        return n === 1 ? jeden : ((r10 >= 2 && r10 <= 4 && (r100 < 12 || r100 > 14)) ? kilka : wiele);
    }

    // Wspolne liczenie dla SSR-podmiany i wnioskow: liczniki, suma "co najmniej jedna para", najczestszy uklad.
    // Suma modelowa jest niedostepna, gdy brakuje ktoregokolwiek skladnika.
    function licz(o, dane) {
        var typuje = (dane && dane.typuje) || TYPUJE;
        var model = (dane && dane.model && dane.model.kolejne) || {};
        var hist = o.kolejne || {}, N = Number(o.losowan) || 0;
        var paraObs = 0, paraModel = 0, paraModelOk = true, modelBrak = false, najR = typuje, najIle = -1, wiersze = [];
        for (var r = 1; r <= typuje; r++) {
            var ile = Number(hist[r]) || 0, pm = num(model[r]);
            if (pm === null) { modelBrak = true; }
            if (r < typuje) { paraObs += ile; if (pm === null) { paraModelOk = false; } else { paraModel += pm; } }
            if (ile > najIle) { najIle = ile; najR = r; }
            wiersze.push({ r: r, pary: typuje - r, ile: ile, pm: pm });
        }
        return { N: N, typuje: typuje, hist: hist, paraObs: paraObs, paraModel: paraModelOk ? paraModel : null,
                 modelBrak: modelBrak, najR: najR, najIle: najIle, najModel: num(model[najR]),
                 bezModel: num(model[typuje]), wiersze: wiersze };
    }
    var pctM = function (p) { return p === null ? '—' : f1(p * 100) + '%'; };

    window.PEWNIAKI_ANALIZA = {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[13] + '/analizy/struktura.json',
        wersja: __pewniaki_inline_cfg[14],
        lata:   '/assets/json/db/' + __pewniaki_inline_cfg[15] + '/lata/',
        pula:   JSON.parse(String(__pewniaki_inline_cfg[16])),
        typuje: TYPUJE,
        // Zakres lat: suma SUROWYCH licznikow blokow z rocznikow (plan V2 §5.3).
        sumujLata: function (roczniki) {
            var hist = {}, N = 0;
            roczniki.forEach(function (r) {
                N += Number(r.losowan) || 0;
                Object.keys(r.kolejne || {}).forEach(function (b) { hist[b] = (hist[b] || 0) + (Number(r.kolejne[b]) || 0); });
            });
            return { losowan: N, kolejne: hist };
        },
        wnioski: function (o, klucz, dane) {
            if (!o || !o.kolejne || !(Number(o.losowan) > 0)) { return [T13.brakD]; }
            var w = licz(o, dane), N = w.N;
            var p1 = T13.para.replace('%1', tys(w.paraObs)).replace('%2', tys(N))
                .replace('%3', slowo(N, T13.losA, T13.losU, T13.losU)).replace('%4', f1(w.paraObs * 100 / N));
            p1 += w.paraModel === null ? T13.paraB : T13.paraM.replace('%1', f1(w.paraModel * 100));
            var p2 = T13.naj.replace('%1', w.najR).replace('%2', w.typuje - w.najR).replace('%3', tys(w.najIle))
                .replace('%4', slowo(w.najIle, T13.losW, T13.losWA, T13.losWA)).replace('%5', f1(w.najIle * 100 / N));
            p2 += w.najModel === null ? T13.najB : T13.najM.replace('%1', f1(w.najModel * 100));
            return [p1, p2];
        },
        render: function (okno, klucz, dane) {
            var sekcja = q('[data-kolejne]'), brak = q('[data-kolejne-brak]'), notaModel = q('[data-kolejne-model-brak]');
            var pusto = !okno || !okno.kolejne || !(Number(okno.losowan) > 0);
            if (sekcja) { sekcja.hidden = pusto; }
            if (brak) { brak.hidden = !pusto; }
            if (pusto) { return; }
            var w = licz(okno, dane), N = w.N;
            var pct = function (x) { return N ? f1(x * 100 / N) + '%' : '—'; };
            if (notaModel) { notaModel.hidden = !w.modelBrak; }
            set('[data-kolejne-n]', tys(N));
            set('[data-kolejne-para-obs]', tys(w.paraObs));
            set('[data-kolejne-para-slowo]', slowo(w.paraObs, T13.losN, T13.losA, T13.losU));
            set('[data-kolejne-para-pct]', pct(w.paraObs));
            set('[data-kolejne-para-model]', pctM(w.paraModel));
            set('[data-kolejne-naj-r]', w.najR);
            set('[data-kolejne-naj-pary]', w.typuje - w.najR);
            set('[data-kolejne-naj-obs]', tys(w.najIle));
            set('[data-kolejne-naj-slowo]', slowo(w.najIle, T13.losN, T13.losA, T13.losU));
            set('[data-kolejne-naj-pct]', pct(w.najIle));
            set('[data-kolejne-naj-model]', pctM(w.najModel));
            var bez = Number(w.hist[w.typuje]) || 0;
            set('[data-kolejne-bez-obs]', tys(bez));
            set('[data-kolejne-bez-slowo]', slowo(bez, T13.losN, T13.losA, T13.losU));
            set('[data-kolejne-bez-pct]', pct(bez));
            set('[data-kolejne-bez-model]', pctM(w.bezModel));
            var tbody = q('[data-kolejne-tabela] tbody');
            if (tbody) {
                tbody.innerHTML = w.wiersze.map(function (x) {
                    return '<tr><td class="liczbowa">' + x.r + '</td><td class="liczbowa">' + x.pary + '</td><td class="liczbowa">'
                        + tys(x.ile) + '</td><td class="liczbowa">' + pct(x.ile) + '</td><td class="liczbowa">' + pctM(x.pm) + '</td></tr>';
                }).join('');
            }
        }
    };
})();
})();
